var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_6594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.235 2.13012L15.2775 5.28012C15.9525 5.80512 16.5 6.92262 16.5 7.77012V13.3276C16.5 15.0676 15.0825 16.4926 13.3425 16.4926H4.6575C2.9175 16.4926 1.5 15.0676 1.5 13.3351V7.87512C1.5 6.96762 2.1075 5.80512 2.85 5.28762L7.485 2.04012C8.535 1.30512 10.2225 1.34262 11.235 2.13012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.4927V11.2427",
    stroke: "#003758",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_6594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.8dc88de709a3916fbe4fc0a39483a937.svg";
export { ForwardRef as ReactComponent };